module.exports = __webpack_public_path__ + "static/img/home_service_center.10e3d0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_service_center.png
// module id = nMd9
// module chunks = 78